import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Shield } from './Icons';
export function GuaranteeSection() {
  return <section className="py-24 bg-olive text-cream relative overflow-hidden" data-id="element-187">
      {/* Subtle background pattern/gradient */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-cream via-transparent to-transparent" data-id="element-188"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-189">
        <FadeIn data-id="element-190">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-cream/10 mb-8" data-id="element-191">
            <Shield size={40} className="text-gold" data-id="element-192" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif mb-8" data-id="element-193">
            Sin riesgo. Sin sorpresas.
          </h2>

          <div className="space-y-6 text-lg text-cream/90 leading-relaxed" data-id="element-194">
            <p data-id="element-195">
              Sabemos que elegir un catering nuevo implica confianza. Por eso
              trabajamos con comunicación abierta desde el primer contacto: Le
              contamos exactamente qué va a recibir, cómo va a lucir y cuándo va
              a llegar.
            </p>
            <p data-id="element-196">
              Sin letra chica. Sin cambios de último momento que usted no
              aprobó. Sin esa ansiedad de no saber si el catering va a estar a
              la altura.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}